var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinetPageCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5278 4.52797V0.950195M5.37222 4.52797V0.950195M8.95 11H12.4222C12.9745 11 13.4222 11.4477 13.4222 12V14H4.47778V12C4.47778 11.4477 4.92549 11 5.47777 11H8.95ZM8.95 11V8.9502M8.95 8.9502C8.95 8.9502 8.45348 9.19529 7.90002 8.9502C6.53319 8.34489 8.95 5.4502 8.95 5.4502C8.95 5.4502 11.2669 8.38393 9.90002 8.9502C9.37687 9.16693 8.95 8.9502 8.95 8.9502ZM15.2111 17.0502H2.68889C1.70091 17.0502 0.899998 16.2493 0.899998 15.2613V4.52797C0.899998 3.54 1.70091 2.73908 2.68889 2.73908L15.2111 2.73908C16.1991 2.73908 17 3.54 17 4.52797V15.2613C17 16.2493 16.1991 17.0502 15.2111 17.0502Z",
    stroke: "#9F9F9F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinetPageCalendar);
export default __webpack_public_path__ + "static/media/clinetPageCalendar.2d3bf43db46a052686a3450a64d91399.svg";
export { ForwardRef as ReactComponent };